/*
 * @Description: 页面说明
 * @Version: 版本号
 * @Author: chuzhangyi
 * @Date: 2023-03-24 10:42:36
 * @LastEditors: 最后一次编辑说明
 * @LastEditTime: 2024-08-22 16:14:33
 * @FilePath: \买家e:\LBB\wechat_business\src\utils\baseConfig.js
 */
import store from '@/store'
import '@/assets/js/vantImport'
import load from '@/components/load/load.js'
import { isWeiXin, getQueryString } from '@/utils/index.js';
import '@/api'
import { Dialog } from 'vant'

function isCustomerInspectionPage() {
  const href = window.location.href || '';
  const path = window.location.pathname || '';
  return path.includes('visit-inspectionCustomer') || href.includes('visit-inspectionCustomer');
}

function resolveWxConfigType() {
  const raw = sessionStorage.getItem('pageType') || getQueryString('agentidtype') || '';
  const num = Number(raw);
  return Number.isFinite(num) && num > 0 ? num : 1;
}

async function getConfigSignature(url) {
  // 根据 url 生成企业签名
  // 生成方法参考 https://developer.work.weixin.qq.com/document/14924
  const { code, data = {} } = await $http.get('wxConfig', {
    params: {
      url,
      type: resolveWxConfigType()
    }
  });
  return {
    timestamp: data.timestamp, nonceStr: data.nonce, signature: data.sign
  }
}

async function getAgentConfigSignature(url) {
  // 根据 url 生成应用签名，生成方法同上，但需要使用应用的 jsapi_ticket
  let { code, data = {} } = await $http.get('agentConfig', {
    params: {
      url,
      type: resolveWxConfigType()
    }
  });
  return {
    timestamp: data.timestamp, nonceStr: data.nonce, signature: data.sign
  }
}


// 自建应用设置微信配置
const setWxConfig = function () {

  return new Promise(async (resolve, reject) => {
    try {
      if (!isWeiXin()) { resolve('请使用企微打开'); return };
      if (isCustomerInspectionPage()) { resolve(); return; }
      load.open();
      let type = resolveWxConfigType();
      const { code, data = {} } = await $http.get('wxConfig', {
        params: {
          url: encodeURIComponent(window.location.href),
          type
        }
      });
      if (code == 200) {
        wx.config({
          beta: true, // 必须这么写，否则ww.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.corpId, // 必填，企业微信的corpID
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonce, // 必填，生成签名的随机串
          signature: data.sign, // 必填，签名，见 附录-JS-SDK使用权限签名算法
          jsApiList: [
            'invoke',
            'hideOptionMenu',
            'agentConfig',
            'openEnterpriseChat',
            'getLocation',
            'openEnterpriseChat',
            'previewImage',
            'openExistedChatWithMsg',
            'shareAppMessage',
            'shareWechatMessage',
            "chooseImage",
            "getLocalImgData"
          ], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        });
        wx.ready(function () {
          wx.checkJsApi({
            jsApiList: ['invoke', 'hideOptionMenu', 'agentConfig', 'openEnterpriseChat', 'getLocation', 'openEnterpriseChat', 'previewImage', 'openExistedChatWithMsg', 'shareAppMessage', 'shareWechatMessage', "chooseImage", "getLocalImgData"], // 需要检测的JS接口列表
            success: function (res) {
              log('config配置成功：', res);
              resolve(res)
            },
            fail: function (err) {
              reject(err)
            }
          });
        });
      }
    } catch (error) {
      load.close();
      reject(error)
    }
  })
};

// 获取企业微信agentConfig配置信息
const setWxAagentConfig = function () {
  return new Promise(async (resolve, reject) => {
    try {
      if (!isWeiXin()) { resolve('请使用企微打开'); return };
      if (isCustomerInspectionPage()) { resolve(); return; }
      // await setWxConfig()
      let type = resolveWxConfigType();
      
      let { code, data = {} } = await $http.get('agentConfig', {
        params: {
          url: window.location.href,
          type
        }
      });
      if (code == 200) {
        ww.register({
          beta: true, // 必须这么写，否则ww.invoke调用形式的jsapi会有问题
          debug: true,
          corpId: data.corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentId: data.agentId, // 必填，企业微信的应用id （e.g. 1000247）
          // timestamp: data.timestamp, // 必填，生成签名的时间戳
          // nonceStr: data.nonce, // 必填，生成签名的随机串
          // signature: data.sign, // 必填，签名，见附录-JS-SDK使用权限签名算法
          getConfigSignature,// 必填，根据url生成企业签名的回调函数
          getAgentConfigSignature,// 必填，根据url生成应用签名的回调函数
          jsApiList: [
            'getCurExternalChat',
            'hideOptionMenu',
            'getContext',
            'launchMiniprogram',
            'getCurExternalContact',
            'sendChatMessage',
            'getLocation',
            'previewImage',
            'openExistedChatWithMsg',
            'openEnterpriseChat',
            'shareAppMessage',
            "chooseImage",
            "getLocalImgData",
            "openLocation"
          ], //必填，传入需要使用的接口名称
          onConfigSuccess(res) {
            console.log('agentConfig配置成功1：', res);
            resolve(res)
          },
          onConfigFail(error) {
            console.log('agentConfig配置失败：', error);
            reject(error)
          },
          onAgentConfigSuccess(res) {
            console.log('agentConfig配置成功2：', res);
            resolve(res)
          },
          onAgentConfigFail(error) {
            console.log('agentConfig配置失败2：', error);
            resolve(error)
          }
        });
        // setTimeout(() => {
        //   wx.agentConfig({
        //     beta: true, // 必须这么写，否则ww.invoke调用形式的jsapi会有问题
        //     debug: true,
        //     corpid: data.corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
        //     agentid: data.agentId, // 必填，企业微信的应用id （e.g. 1000247）
        //     timestamp: data.timestamp, // 必填，生成签名的时间戳
        //     nonceStr: data.nonce, // 必填，生成签名的随机串
        //     signature: data.sign, // 必填，签名，见附录-JS-SDK使用权限签名算法
        //     jsApiList: ['getCurExternalChat', 'getContext', 'launchMiniprogram', 'getCurExternalContact', 'sendChatMessage', 'getLocation', 'previewImage', 'openExistedChatWithMsg', 'shareAppMessage', "chooseImage", "getLocalImgData"], //必填，传入需要使用的接口名称
        //     success: function (res) {
        //       log('agentConfig配置成功1：', res);
        //       resolve(res)
        //       load.close();
        //     },
        //     fail: function (error) {
        //       reject(error)
        //       // if (res.errMsg.indexOf('function not exist') > -1) {
        //       //   alert('版本过低请升级')
        //       // }
        //     }
        //   });
        // }, 500)
      } else {
        resolve({ code, data })
      }
    } catch (error) {
      reject(error)
      load.close();
    }
  })
};

// 获取群id(自建应用)
const getCurExternalChat = function (id, resolve1) {

  return new Promise((resolve, reject) => {
    try {
      ww.invoke('getCurExternalChat', {}, function (res) {
        log('获取群id成功：', res);
        if (res.err_msg == "getCurExternalChat:ok") {
          store.dispatch('setChatId', res.chatId);
        }
        resolve(res);
      });
    } catch (error) {
      reject(error)
    }
  })
};

// 获取当前聊天客户信息(自建应用)
const getCurExternalContact = async function (externalUserId, resolve1) {
  if (externalUserId) {
    console.log('getCurExternalContact', externalUserId);
    const { code, data } = await $http.get('getExternalContactByWxUserId', { params: { externalUserId } });
    if (code == 200) {
      store.dispatch('setCurExternalContact', data);
    } else {
      store.dispatch('setCurExternalContact', {});
    }
    resolve1 && resolve1(data);
    return
  } else {
    return new Promise((resolve, reject) => {
      ww.invoke('getCurExternalContact', {}, async function (res) {
        log('获取当前聊天客户信息成功：', res);
        if (res.err_msg == "getCurExternalContact:ok") {
          const { code, data = {} } = await $http.get('getExternalContactByWxUserId', { params: { externalUserId: res.userId } });
          if (code == 200) {
            store.dispatch('setCurExternalContact', { ...data, ...res });
          } else {
            store.dispatch('setCurExternalContact', res);
          }
          resolve(res);
        } else {
          //错误处理
          reject(res)
        }
      });

    })
  }

};

// 获取当前销售信息(自建应用)
const getSalesInfo = function (codeU, type) {
  return new Promise(async (resolve, reject) => {
    try {
      const { code, data } = await $http.get('getUserByCode', { params: { code: codeU, type } });
      log('获取当前销售信息(自建应用):', data)
      if (code == 200) {
        store.dispatch('setSalesInfo', { ...data, name: data.sysUserName || data.name });
        window.tracker.updateUser({
          userid: data.userId,
          name: data.sysUserName
        });
      }
      resolve({ code, data })
    } catch (error) {
      reject(error)
    }
  })
};

// 授权获取code
const getCode = function () {
  // 重定向 URL
  const redirect_uri = decodeURIComponent(window.location.href);
  // 授权链接 URL
  let appId = sessionStorage.getItem('appId');
  const login_url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(redirect_uri)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
  // 向授权链接 URL 跳转
  window.location.replace(login_url);
};

// 获取主体列表(单人聊天)
const getUserInfo = function ({ chatType }) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!store.state.curExternalContact.unionId) {
        reject('未获取到用户id')
        return
      };
      load.open();
      let { code, data = [] } = await $http.post('queryWechatUserByUnionId', {
        unionId: store.state.curExternalContact.unionId,
        chatType: chatType || 1
      });
      if (code == 200) {
        store.dispatch('setUserList', data || []);
        if (!store.state.userInfo.userId) {
          store.dispatch('setUserInfo', (data || []).filter(item => item.defaultBody == 1)[0] || (data || [])[0] || {});
        } else {
          store.dispatch('fetchUserCertificationType');
        }
        resolve({ code, data })
      }
    } catch (error) {
      reject(error)
    } finally {
      load.close();
    }
  })
}

// 获取主体列表(自建 群)
const getUserList = function ({ chatId = store.state.chatId, chatType }) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!chatId) {
        reject('未获取到群id')
        return
      };
      load.open();
      let { code, data = [] } = await $http.post('queryWechatUserByChatId', {
        chatId: chatId,
        chatType: chatType || 1
      });
      if (code == 200) {
        store.dispatch('setUserList', data || []);
        if (!store.state.userInfo.userId) {
          store.dispatch('setUserInfo', data.filter(item => item.defaultBody == 1)[0] || data[0] || {});
        } else {
          store.dispatch('fetchUserCertificationType');
        }
      }
      resolve({ code, })
    } catch (error) {
      reject(error)
    } finally {
      load.close();
    }
  })
};

// 获取进入H5页面的入口环境(自建)
const getContext = function () {
  return new Promise((resolve, reject) => {
    try {
      const entry = getQueryString('entry');

      if (!wx.miniProgram) {
        ww.invoke('getContext', {}, async function (res) {
          log('获取进入H5页面的入口环境成功：', res);
          if (res.err_msg == "getContext:ok") {
            store.dispatch('setEntry', res.entry);
            if (res.entry == 'group_chat_tools') {
              await getCurExternalChat();
            } else if (res.entry == 'single_chat_tools') {
              await getCurExternalContact()
            }
          }
          resolve(res)
        });
      } else {
        wx.miniProgram.getEnv(async function (res) {
          if (res.miniprogram) {
            console.log('小程序进入，entry：', entry);
            store.dispatch('setEntry', entry);
            if (entry == 'group_chat_tools') {
              console.log('小程序进入，chatId：', getQueryString('chatId'));
              store.dispatch('setChatId', getQueryString('chatId'));
              resolve({})
            } else if (entry == 'single_chat_tools') {
              console.log('小程序进入，userId：', getQueryString('userId'));
              store.dispatch('setCurExternalContact', {
                userId: getQueryString('userId'),
                externalUserId: getQueryString('userId')
              });
              const { code, data } = await $http.get('getExternalContactByWxUserId', { params: { externalUserId: getQueryString('userId') } });
              if (code == 200) {
                store.dispatch('setCurExternalContact', data);
              } else {
                store.dispatch('setCurExternalContact', {});
              }
              resolve(res)

            } else {
              resolve({})
            }
          } else {
            ww.invoke('getContext', {}, async function (res) {
              log('获取进入H5页面的入口环境成功：', res);
              if (res.err_msg == "getContext:ok") {
                store.dispatch('setEntry', res.entry);
                if (res.entry == 'group_chat_tools') {
                  await getCurExternalChat();
                } else if (res.entry == 'single_chat_tools') {
                  await getCurExternalContact()
                }
              }
              resolve(res)
            });
          }
        })
      }
    } catch (error) {
      reject(error)
    }
  })
};

// 初始化用户列表信息
const initUser = function ({ source }) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log({ entry: store.state.entry })
      if (store.state.entry == 'single_chat_tools') {
        await getUserInfo({ chatType: source });
      } else if (store.state.entry == 'group_chat_tools') {
        await getUserList({ chatType: source });
      };
      resolve();
    } catch (error) {
      reject(error);
    }
  })
}

// 获取定位信息
const getLocation = function () {
  return new Promise(async (resolve, reject) => {
    try {
      await setWxAagentConfig(); // 获取企业微信agentConfig配置信息

      // resolve({
      //   longitude: 120.02,
      //   latitude: 33.34,
      // })
      // resolve({
      //   longitude: 121.59,
      //   latitude: 31.06
      // })
      // return



      console.log(111, 'wx.getLocation');
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: (res) => {
          // var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          // var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          // var speed = res.speed; // 速度，以米/每秒计
          // var accuracy = res.accuracy; // 位置精度
          console.log('getLocation:', res);
          resolve(res);
        },
        fail: (err) => {
          console.log('getLocationFail:', err);
          reject(err)
        },
        cancel: () => {
          Dialog.alert({
            title: '系统提示',
            message: '未打开gps授权，请前往企微-设置-个人信息与权限-系统权限管理-位置 打开此功能'
          })
          console.log(11111);
        },
        compelete: () => {
          console.log(22222);
        }
      });
    } catch (error) {
      console.log('getLocationError:', error);
      reject(error)
    }
  })
}

// 分享消息到当前会话
const sendChatMessage = function (params = { msgtype: 'text', text: { content: "你好" } }) {
  return new Promise(async (resolve, reject) => {
    try {
      // await setWxAagentConfig(); // 获取企业微信agentConfig配置信息
      if (!wx.miniProgram) {
        ww.invoke('sendChatMessage', params, function (res) {
          console.log('sendChatMessage:', res);
          if (res.err_msg == 'sendChatMessage:ok') {
            //发送成功
            resolve()
          } else if (res.err_msg != 'sendChatMessage:cancel') {
            shareWechat(params.news, resolve, reject)
            resolve()
          } else {
            reject(res)
          }
        })
      } else {
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            wx.miniProgram.navigateTo({ url: '/pages/test/index?methods=sendChatMessage&params=' + encodeURIComponent(JSON.stringify(params)) })
          } else {
            ww.invoke('sendChatMessage', params, function (res) {
              console.log('sendChatMessage:', res);
              if (res.err_msg == 'sendChatMessage:ok') {
                //发送成功
                resolve()
              } else if (res.err_msg != 'sendChatMessage:cancel') {
                shareWechat(params.news, resolve, reject)
                resolve()
              } else {
                reject(res)
              }
            })
          }
        })
      }

    } catch (error) {
      console.log('sendChatMessageError:', error);
      reject(error)
    }
  })
}

const shareWechat = function (params, resolve, reject) {
  ww.invoke(
    "shareAppMessage", params, function (res) {
      if (res.err_msg == "shareAppMessage:ok") {
        resolve()
      } else if (res.err_msg !== "shareAppMessage:cancel") {
        console.log("分享失败:", res)
        try {
          console.log("分享失败: 执行小程序分享")
          wx.miniProgram && wx.miniProgram.navigateTo({ url: '/pages/test/index?methods=shareAppMessage&params=' + encodeURIComponent(JSON.stringify(params)) })
          // wx.miniProgram.postMessage({ data: { methods: 'shareAppMessage', params } })
          resolve()
        } catch (error) {
          reject()
        }
      }
    }
  );
}

export {
  setWxConfig,
  setWxAagentConfig,
  getSalesInfo,
  getCode,
  initUser,
  getCurExternalChat,
  getCurExternalContact,
  getContext,
  getLocation,
  sendChatMessage
}
